import { useAnalysisStore } from '@modules/analysis/store/analysisStore';
import { QuantifyAnomaliesThreshold } from '@modules/quantify/components/QuantifyAnomaliesToggle/QuantifyAnomaliesThreshold';
import {
  DEFAULT_ANOMALY_THRESHOLD,
  DEFAULT_QUANTIFY_SORT_BY,
} from '@modules/quantify/constants';
import { useFetchQuantifyReport } from '@modules/quantify/hooks';
import { QuantifyActionType } from '@modules/quantify/store/quantifyActionType';
import { useQuantifyStore } from '@modules/quantify/store/quantifyStore';
import { FormControlLabel, Stack, Switch } from '@mui/material';
import { ChangeEvent, useState } from 'react';
import { useUpdateEffect } from 'react-use';
import { createAnalyticsTracker } from 'v2/analytics/events';
import { shallow } from 'zustand/shallow';

export const trackQuantifyAnomaliesEvent =
  createAnalyticsTracker('quantifyAnomalies');

export const QuantifyAnomaliesToggle = () => {
  const dispatch = useQuantifyStore(({ dispatch }) => dispatch);

  const shouldShowAnomalies = useQuantifyStore(
    ({ query }) => query.shouldShowAnomalies,
  );

  const groupByLabel = useQuantifyStore(
    ({ query }) => query.groupByField?.displayName,
  );

  const fetchQuantifyReport = useFetchQuantifyReport();
  const [shouldFetchReportData, setShouldFetchReportData] = useState(false);

  const { title: name, href } = useAnalysisStore(
    ({ title, href, scope }) => ({ title, href, scope }),
    shallow,
  );

  useUpdateEffect(() => {
    if (shouldFetchReportData) {
      setShouldFetchReportData(false);
      fetchQuantifyReport();
    }
  }, [shouldFetchReportData]);

  const onChange = (_: ChangeEvent<HTMLInputElement>, checked: boolean) => {
    if (checked) {
      dispatch({
        type: QuantifyActionType.SET_QUERY,
        payload: {
          anomalyThreshold: DEFAULT_ANOMALY_THRESHOLD,
          shouldShowAnomalies: true,
        },
      });
    } else {
      dispatch({
        type: QuantifyActionType.SET_QUERY,
        payload: {
          anomalyThreshold: undefined,
          shouldShowAnomalies: false,
          shouldShowTopDataPoints: true,
          visibleDataPoints: [],
        },
      });
    }

    dispatch({
      type: QuantifyActionType.SET_QUERY,
      payload: {
        sortBy: checked ? null : DEFAULT_QUANTIFY_SORT_BY,
      },
    });

    setShouldFetchReportData(true);

    trackQuantifyAnomaliesEvent({
      eventName: checked
        ? 'Quantify Anomalies - Toggled On'
        : 'Quantify Anomalies - Toggled Off',
      query: {
        showMeLabel: groupByLabel,
      },
      name,
      link: href,
    });
  };

  return (
    <Stack direction="row" alignItems="center" spacing={0.5}>
      <FormControlLabel
        control={
          <Switch
            checked={shouldShowAnomalies}
            onChange={onChange}
            size="small"
          />
        }
        label="Show Anomalies"
        componentsProps={{
          typography: {
            variant: 'body2',
          },
        }}
        sx={{
          mr: 0,
        }}
      />
      <QuantifyAnomaliesThreshold />
    </Stack>
  );
};
